import { useStore } from "src/stores/Store";
import tw from "src/utils/tw";

export function AddItemHeader(props) {
  const store = useStore();

  return (
    <div
      className={tw(
        "border-b",
        "border-borderGray",
        "fixed",
        "top-0",
        "left-0",
        "w-full",
        "bg-white",
        "z-30",
        store.user?.isSalesOrAbove ? "h-28" : "h-20",
        store.user?.isSalesOrAbove ? "pt-11" : "pt-4",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
